export const keyboardSettings = {
    layout: 'custom',
    usePreview: false,
    customLayout: {
        'default': ['1 2 3', '4 5 6', '7 8 9 0', '{a} {c} {b}']
    },
    position: {
        of : null,
        my : 'center top-178',
        at : 'center top',
        at2: 'center top',
        collision: 'none none'
    },
    reposition: false,
    autoAccept: true,
    autoAcceptOnEsc: true,
    caretToEnd: true,
    preventPaste: true // блокирует правую кнопку мыши
};